'use strict';

define(['app', 'productSingleImage', 'productPrice', 'productNutritionalIcons', 'productVariations', 'productQuantityInput', 'productAddToBasket', 'productStockInformation', 'productViewMoreInformation', 'subscriptionComponent'], function (app, productSingleImage, productPrice, productNutritionalIcons, productVariations, productQuantityInput, productAddToBasket, productStockInformation, productViewMoreInformation, subscriptionComponent) {

  var created = false;
  var emptyComponent = {
    init: function init() {}
  };

  var productQuickbuy = function productQuickbuy() {
    var component = {};

    var _config = {
      selectors: {
        loading: '[data-loading]',
        error: '[data-error]',
        openTrigger: '[data-open-product-quickbuy]',
        closeModalButton: '[data-close]',
        gallery: '[data-gallery]'
      },
      classes: {
        showLoading: 'productQuickbuy_loading-show',
        showError: 'productQuickbuy_error-show',
        showQuickbuy: 'productQuickbuy-show'
      },
      subscribedChannelsToClear: {
        image: 'productSingleImage/newImage',
        price: 'productPrice/newPrice',
        icons: 'productNutritionalIcons/newIcons',
        stock: 'productStockInformation/newStockInformation',
        information: 'productViewMoreInformation/newUrl'
      },
      productAttribute: '[data-child-id]',
      productSku: 'data-child-id',
      productBlockSku: 'data-sku',
      recommendationContext: 'data-context',
      recommendationParentAttribute: '[data-component=productRecommendations]',
      fromWishlist: 'data-from-wishlist'
    };

    var _init = function _init(element, userDriven) {
      component.element = element;
      component.loading = component.element.querySelector(component.config.selectors.loading);
      component.error = component.element.querySelector(component.config.selectors.error);
      component.closeModalButton = component.element.querySelector(component.config.selectors.closeModalButton);
      component.gallery = document.querySelector(component.config.selectors.gallery);

      if (component.element.querySelector(component.config.productAttribute)) {
        component.productId = component.element.querySelector(component.config.productAttribute).getAttribute(component.config.productSku);
      }

      if (!userDriven) {
        component.subscribe();
      }

      component.context = component.getRecommendationContext();
      component.bindOpenTrigger();
      component.bindCloseTrigger();

      return component;
    };

    var _subscribe = function _subscribe() {
      app.subscribe('productQuickbuy/startLoading', component.startLoading);
      app.subscribe('productQuickbuy/stopLoading', component.stopLoading);
      app.subscribe('productQuickbuy/showError', component.showError);
      app.subscribe('productQuickbuy/hideError', component.hideError);
      app.subscribe('productQuickbuy/hideModal', component.hideModal);
      app.subscribe('productQuickbuy/reinitialise', component.reinitialiseComponent);
    };

    var _bindOpenTrigger = function _bindOpenTrigger() {
      component.openTriggers = document.querySelectorAll(component.config.selectors.openTrigger);
      for (var i = 0, l = component.openTriggers.length; i < l; i++) {
        component.openTriggers[i].removeEventListener('click', component.loadModal);
        component.openTriggers[i].addEventListener('click', component.loadModal);
      }

      if (component.closeModalButton) {
        component.closeModalButton.removeEventListener('click', component.hideModal);
        component.closeModalButton.addEventListener('click', component.hideModal);
      }
    };

    var _bindCloseTrigger = function _bindCloseTrigger() {
      if (component.closeModalButton) {
        component.closeModalButton.removeEventListener('click', component.hideModal);
        component.closeModalButton.addEventListener('click', component.hideModal);
      }
    };

    var _loadModal = function _loadModal(event) {
      event.preventDefault();

      app.publish('tracking/record', 'Product | quickBuy', 'clicked', 'quickBuy button');

      var productId = app.element.getAttribute(component.config.productBlockSku, event.target);
      var fromWishlist = app.element.getAttribute(component.config.fromWishlist, event.target);
      var url = '/' + productId + '.quickbuy';
      var queryParams = [];
      if (component.gallery) {
        queryParams.push('variationSelect=true');
      }
      if (component.context) {
        queryParams.push('rctxt=' + component.context);
      }

      if (fromWishlist) {
        queryParams.push('fromWishlist=' + fromWishlist);
      }

      var queryString = queryParams.join('&');
      if (queryString) {
        url += '?' + queryString;
      }

      app.ajax.get({
        url: url,
        dataType: 'JSON',
        error: component.showError,
        success: component.attachModal
      });
    };

    var _attachModal = function _attachModal(response) {
      component.element.outerHTML = response;
      component.initialiseAllComponents();
    };

    var _reinitialiseComponent = function _reinitialiseComponent() {
      var newProductQuickbuyObject = document.querySelector('[data-component=productQuickbuy]');
      component.init(newProductQuickbuyObject, true);
    };

    var _initialiseAllComponents = function _initialiseAllComponents() {
      //productQuickbuy
      var newProductQuickbuy = document.querySelector('[data-component=productQuickbuy]');
      component.init(newProductQuickbuy, true);

      //productSingleImage
      var newProductSingleImage = newProductQuickbuy.querySelector('[data-component=productSingleImage]');
      new productSingleImage().init(newProductSingleImage);

      //productPrice
      var newProductPrice = newProductQuickbuy.querySelector('[data-component=productPrice]');
      new productPrice().init(newProductPrice);

      //productNutritionalIcons
      var newProductNutritionalIcons = newProductQuickbuy.querySelector('[data-component=productNutritionalIcons]');
      if (newProductNutritionalIcons) {
        new productNutritionalIcons().init(newProductNutritionalIcons);
      }

      //productQuantityInput
      var newProductQuantityInput = newProductQuickbuy.querySelector('[data-component=productQuantityInput]');
      new productQuantityInput().init(newProductQuantityInput);

      //productVariations
      var newProductVariations = newProductQuickbuy.querySelector('[data-component=productVariations]');
      if (newProductVariations) {
        new productVariations().init(newProductVariations);
      }

      //productAddToBasket
      var newProductAddToBasket = newProductQuickbuy.querySelector('[data-component=productAddToBasket]');
      new productAddToBasket().init(newProductAddToBasket);

      //productStockInformation
      var newProductStockInformation = newProductQuickbuy.querySelector('[data-component=productStockInformation]');
      new productStockInformation().init(newProductStockInformation);

      //productViewMoreInformation
      var newProductViewMoreInformation = newProductQuickbuy.querySelector('[data-component=productViewMoreInformation]');
      new productViewMoreInformation().init(newProductViewMoreInformation);

      //subscriptionComponent
      var newProductSubscriptionComponent = newProductQuickbuy.querySelector('[data-component=subscriptionComponent]');
      if (newProductSubscriptionComponent) {
        new subscriptionComponent().init(newProductSubscriptionComponent);
      }

      component.showModal(newProductQuickbuy);
    };

    var _showModal = function _showModal(modalInstance) {
      if (modalInstance) {
        app.element.addClass(component.config.classes.showQuickbuy, modalInstance);
      } else {
        app.element.addClass(component.config.classes.showQuickbuy, component.element);
      }

      document.body.style.top = '-' + window.scrollY + 'px';
      document.body.style.position = 'fixed';
      document.body.style.width = '100vw';

      app.publish('tracking/record', 'Product | quickBuy', 'viewed', 'quickBuy modal');
    };

    var _hideModal = function _hideModal() {
      for (var channel in component.config.subscribedChannelsToClear) {
        if (component.config.subscribedChannelsToClear.hasOwnProperty(channel)) {
          app.clear(component.config.subscribedChannelsToClear[channel]);
        }
      }

      if (document.body.style.position === 'fixed') {
        var prevScrollTop = -1 * parseFloat(document.body.style.top);
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, prevScrollTop);
        document.body.style.width = '';
      }

      app.element.removeClass(component.config.classes.showQuickbuy, component.element);
      app.publish('tracking/record', 'Product | quickBuy', 'clicked', 'close modal');
    };

    var _showError = function _showError() {
      app.element.addClass(component.config.classes.showError, component.error);
    };

    var _hideError = function _hideError() {
      if (component.error) {
        app.element.removeClass(component.config.classes.showError, component.error);
      }
    };

    var _startLoading = function _startLoading() {
      if (component.loading) {
        app.element.addClass(component.config.classes.showLoading, component.loading);
      }
    };

    var _stopLoading = function _stopLoading() {
      if (component.loading) {
        app.element.removeClass(component.config.classes.showLoading, component.loading);
      }
    };

    var _tracking = function _tracking() {
      app.publish('tracking/record', 'Product | quickBuy', 'viewed', component.productId);
    };

    var _getRecommendationContext = function _getRecommendationContext() {
      // polyfill for IE8+
      if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
      }

      if (!Element.prototype.closest) {
        Element.prototype.closest = function (s) {
          var el = this;
          if (!document.documentElement.contains(el)) return null;
          do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
          } while (el !== null && el.nodeType === 1);
          return null;
        };
      }

      var recommendationParent = component.element.closest(component.config.recommendationParentAttribute);
      return recommendationParent ? recommendationParent.getAttribute(component.config.recommendationContext) : '';
    };

    component.init = _init;
    component.subscribe = _subscribe;
    component.reinitialiseComponent = _reinitialiseComponent;
    component.config = _config;
    component.bindOpenTrigger = _bindOpenTrigger;
    component.bindCloseTrigger = _bindCloseTrigger;
    component.initialiseAllComponents = _initialiseAllComponents;
    component.startLoading = _startLoading;
    component.stopLoading = _stopLoading;
    component.loadModal = _loadModal;
    component.attachModal = _attachModal;
    component.showModal = _showModal;
    component.hideModal = _hideModal;
    component.showError = _showError;
    component.hideError = _hideError;
    component.tracking = _tracking;
    component.getRecommendationContext = _getRecommendationContext;

    return component;
  };

  return function () {
    if (created) return emptyComponent;
    created = true;
    return new productQuickbuy();
  };
});
//# sourceMappingURL=productQuickbuy.js.map
